type TErrorBody = { error?: { message?: unknown } | string; message?: unknown };

const isNonEmptyString = (value: unknown): value is string => typeof value === 'string' && value.length > 0;

export const errorMessageFrom = async (response: Response, fallback: string): Promise<string> => {
  const body: TErrorBody | undefined = await response.json().catch(() => undefined);
  const standardMessage = typeof body?.error === 'object' ? body.error?.message : undefined;
  if (isNonEmptyString(standardMessage)) return standardMessage;
  if (isNonEmptyString(body?.message)) return body.message;
  return fallback;
};
